import { getDocs, query, where } from 'firebase/firestore';
import { YearSegment } from '../types/category';
import { StudentRating } from '../types/student-rating';
import BaseService from './base-service';

class StudentRatingsService extends BaseService<StudentRating> {
  constructor() {
    super('studentratings');
  }

  async getByStudentIdAndSubjectIdAndYear(
    studentId: string,
    subjectId: string,
    year: number,
    yearSegment: YearSegment
  ): Promise<StudentRating | undefined> {
    const q = query(
      this.collectionRef,
      where('studentId', '==', studentId),
      where('subjectId', '==', subjectId),
      where('year', '==', year),
      where('yearSegment', '==', yearSegment)
    );

    const snapshot = await getDocs(q);

    if (snapshot.empty) return undefined;

    const doc = snapshot.docs[0];

    return { id: doc.id, ...(doc.data() as StudentRating) };
  }
}

const studentRatingsService = new StudentRatingsService();
export default studentRatingsService;
